import type { Action } from 'redux';
import dash_api from '../../../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../../../services/ReduxAsyncAction';
import type { GetGoogleAccountsPayload } from '../GoogleAds.types';

const GetGoogleAdsAdAccounts = new ReduxAsyncAction<'GET_GOOGLE_ADS_AD_ACCOUNTS', string, GetGoogleAccountsPayload>(
  'GET_GOOGLE_ADS_AD_ACCOUNTS'
);
GetGoogleAdsAdAccounts.registerRequest((credentialId: string) => {
  return dash_api.get(`/v1/google/get-accounts?credential_id=${credentialId}`).then(({ data }) => {
    return {
      accounts: Array.isArray(data) ? data : [],
    };
  });
});
export const GET_GOOGLE_ADS_AD_ACCOUNTS = GetGoogleAdsAdAccounts.actionNamespaceConstants;
export const getGoogleAdsAdAccounts = GetGoogleAdsAdAccounts.request;
export type GetGoogleAdsAdAccountsAction = Action<
  typeof GET_GOOGLE_ADS_AD_ACCOUNTS.response | typeof GET_GOOGLE_ADS_AD_ACCOUNTS.request
> & {
  data: GetGoogleAccountsPayload;
};
